import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { showLoader } from "../../redux/actions/action_loader";
import "./GenerateOtp.css";
import Error from "./../Error/Error";
import { getApiData } from "../../api/api";
import Otp from "./Otp/Otp";
import Snackbar from "../Snackbar/Snackbar";
import {
  physicalJourneyText,
  clubbedOTPDisclaimer,
  CisJourneyText,
  cisDisclaimerText,
  CisDisclaimerTextForGenOtp,
  CisIsNpsDisclaimerText,
  regularAlertsDiscalimer
} from "../../utils/disclaimerText";
import { DECLRATION_IDS, GENERATE_OTP_ATTEMPTS_ALLOWED, ROUTES, TELEBINDING_STAGES, YES } from "../../utils/constants";
import { withTranslation } from "react-i18next";
import {
  hybridPosvSteps,
  isNpsSteps,
  photoVerificationSteps,
  QCSteps,
} from "../../utils/stepperStep";
import AxiosRequest from "../../utils/axios";
import { handleProgress, isNewUI } from "../../utils/handleProgress";
import cryptoJs from "crypto-js";
import BlockedJourneyNew from "../POSV_New_Ui/BlockedJourneyNew/BlockedJourneyNew";
import ClubbedOtp from "../ClubbedOtp/ClubbedOtp";
import { SpeakerContext } from "../../context/SpeakerContext";
import GenerateOtpOld from "../GenerateOtpOld/GenerateOtpOld";
import GoGreenSection from "../POSV_New_Ui/GoGreenSection/GoGreenSection";
import DotsLoader from "../Loader/DotsLoader/DotsLoader";
import MergeChunkErrorDialog from "../POSV_New_Ui/MergeChunkErrorDialog/MergeChunkErrorDialog";
import Axios from "axios";
import BIPage from "../BenefitIllustration/BIPage";
import { CAPS_N, CAPS_Y } from "../../utils/constants";
import { getOTPDeclarationFromStorage, getTodayDate } from "../../utils/handleData";
import { getUserLang } from "../../utils/handleVoiceAndLang";
import { Button } from "unified-ui-components-library";
import { CallIcon } from "unified-ui-components-library/dist/systemIcons";
import GoGreenPolicyPack from "../POSV_New_Ui/GoGreenSection/GoGreenPolicyPack";
import { getConfigFromStroage } from "../../utils/getUrlsFromAws";

const axios = new AxiosRequest().getClient();

class GenerateOtp extends Component {
  constructor() {
    super();
    this.state = {
      autoFilledOtp: "Y",
      generatingOtp: false,
      submitting: false,
      disableSubmitButton: true,
      disableGenerateOtpButton: false,
      otp: undefined,
      otpButtonText: "Generate OTP",
      showCallButton: false,
      disableCallButton: false,
      enableOtpButton: "Y",
      enableOtpOnCallButton: "Y",
      callAttemptsSuccess: 0,
      generateOtpAttempts: 0,
      generateOtpTime: 60,
      callOtpTime: 60,
      showGenerateOtpTime: false,
      showGenerateOtpbtn: true,
      showCallTime: false,
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
      displayMessage: "",
      checkboxValue: false,
      channelName: localStorage.getItem("channelName"),
      showOTPPage: localStorage.getItem("restrictOTP"),
      errorMsg: localStorage.getItem("restrictOTPMsg"),
      ulipStatus: localStorage.getItem("ulipStatus"),
      journeyBy: localStorage.getItem("journeyBy"),
      isNps: localStorage.getItem("isNps"),
      isVideoPosv: localStorage.getItem("isVideoPosv"),
      twoStep: localStorage.getItem("twoStep"),
      submissionRestricted: "",
      businessMsg: "",
      attemptErrorMsg: "",
      physicalJourneyEnabled: localStorage.getItem("physicalJourneyEnabled"),
      declarationObj: {},
      lessText: true,
      btnText: "Read more",
      wrongOtpErr: false,
      posvRefNumber: localStorage.getItem("posvRefNumber"),
      showClubbedOtpPage:
        localStorage.getItem("journeyBy") == "P" ? true : false,
      showBiPage: localStorage.getItem("journeyBy") == "P" ? false : (localStorage.getItem("showBiDetails") === 'Y' ? true : false),
      isWipClubbed: localStorage.getItem("isWipClubbed"),
      isPanAadharLinked: localStorage.getItem("isPanAadharLinked"),
      customerConsentAfyp: localStorage.getItem("customerConsentAfyp"),
      aadharCheckbox: false,
      goGreenFlag: 'Y',
      showGoGreenSection: localStorage.getItem("showGoGreenSection"),
      cis: localStorage.getItem("cis"),
      getAlertsCheckbox: CAPS_Y,
      cisConsentOnOtp: "",
      lPosv: localStorage.getItem("lPosv"),
      isPanLinked: localStorage.getItem("isPanLinked"),
      isBasbaConsentChecked: true,
      isUpfrontPaymentConsentChecked: false,
      isBasbaConsentApplicable: localStorage.getItem("basbaConsent") === CAPS_Y,
      isUpfrontPaymentConsentApplicable: localStorage.getItem("upfrontPaymentConsent") === CAPS_Y,
      isTmbChannel: localStorage.getItem("isTmbChannel") === CAPS_Y,
      showNewGoGreenUi: localStorage.getItem("showNewGoGreenUi") === CAPS_Y,
      isTelebindingJourney: sessionStorage.getItem("isTelebinding") === CAPS_Y,
      isTmbChannel: localStorage.getItem("isTmbChannel") === CAPS_Y,
      showNewGoGreenUi: localStorage.getItem("showNewGoGreenUi") === CAPS_Y,
    };
  }

  componentDidMount() {
    const { showClubbedOtpPage, showBiPage, lPosv, isTelebindingJourney } = this.state;
    const { handleAudioIconDisplay } = this.context;
    handleAudioIconDisplay(false);
    handleProgress(90);
    this.props.showLoader(false);
    window.scrollTo(0, 0);
    document.addEventListener("keyup", this.inputFunction);
    let declarationObj = this.getOTPDeclaration();
    this.setState({ declarationObj });
    console.log({ lPosv })
    if(isTelebindingJourney) {
      this.setState({ disableSubmitButton: false })
    }
    if (isNewUI() && (!showClubbedOtpPage || lPosv === "true") && !showBiPage && !isTelebindingJourney) {
      this.generateOtp("generate");
    }
  }

  getEncryptedData = () => {
    const { posvRefNumber } = this.state;
    let urlsData = getConfigFromStroage();
    const defaultEncryptionKey = urlsData["defaultEncryptionKey"];
    let key = defaultEncryptionKey
    let encryptedBase64Key = btoa(key);
    let parsedBase64Key = cryptoJs.enc.Base64.parse(encryptedBase64Key);
    let encryptedData = "";

    let posvrefnum = posvRefNumber;
    encryptedData = cryptoJs.AES.encrypt(posvrefnum, parsedBase64Key, {
      mode: cryptoJs.mode.ECB,
      padding: cryptoJs.pad.Pkcs7,
    });
    return encryptedData.toString();
  };

  getLanguage = () => {
    let language = localStorage.getItem("LanguageSelected");
    if (language === "eng") {
      return "English";
    }
    if (language === "hin") {
      return "Hindi";
    }
    return language;
  };

  readMoreText = () => {
    const { lessText } = this.state;
    if (lessText) {
      this.setState({ lessText: false, btnText: "Read less" });
    } else {
      this.setState({ lessText: true, btnText: "Read more" });
    }
  };

  getOTPDeclaration = () => {
    const {
      channelName,
      isNps,
      physicalJourneyEnabled,
      journeyBy,
      ulipStatus,
      cis,
      cisConsentOnOtp
    } = this.state;
    const {
      CIS_JOURNEY_TEXT, PHYSICAL_JOURNEY_TEXT,
      CIS_DISCLAIMER_TEXT, DISCLAIMER_TEXT,
      CIS_DISCLAIMER_TEXT_FOR_GEN_OTP, CLUBBED_OTP_DISCLAIMER,
      CIS_IS_NPS_DISCLAIMER_TEXT,
      IS_NPS_DISCLAIMER_TEXT,
      ULIP_DISCLAIMER_TEXT, DISCLAIMER_TEXT_FOR_GEN_OTP
    } = DECLRATION_IDS;
    let declarationObj = {
      showDeclaration: true,
      declaration: "",
    };
    if (physicalJourneyEnabled === "yes") {
      const decId = (cis === YES) ? CIS_JOURNEY_TEXT : PHYSICAL_JOURNEY_TEXT;
      declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
      this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      return declarationObj;
    }

    if (channelName === "x" || journeyBy == "P") {
      if (channelName === "x") {
        const decId = (cis === YES) ? CIS_DISCLAIMER_TEXT : DISCLAIMER_TEXT;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
        declarationObj.showDeclaration = true;
      } else {
        const decId = (cis === YES) ? CIS_DISCLAIMER_TEXT_FOR_GEN_OTP : CLUBBED_OTP_DISCLAIMER;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
        declarationObj.showDeclaration = true;
        // declarationObj.declaration = "";
        // declarationObj.showDeclaration = false;
      }
      return declarationObj;
    }
    if (channelName !== "x") {
      if (isNps === "Y") {
        const decId = (cis === YES) ? CIS_IS_NPS_DISCLAIMER_TEXT : IS_NPS_DISCLAIMER_TEXT;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      } else if (ulipStatus === "Yes") {
        const decId = ULIP_DISCLAIMER_TEXT;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      } else {
        const decId = (cis === YES) ? CIS_DISCLAIMER_TEXT_FOR_GEN_OTP : DISCLAIMER_TEXT_FOR_GEN_OTP;
        declarationObj.declaration = getOTPDeclarationFromStorage(decId)[getUserLang()];
        this.setState({ cisConsentOnOtp: getOTPDeclarationFromStorage(decId) });
      }
      return declarationObj;
    }
  };

  componentWillUnmount() {
    document.removeEventListener("keyup", this.inputFunction);
  }

  inputFunction = () => {
    const [i0, i1, i2, i3, i4, i5] = document.querySelectorAll(".input_otp");
    if (i0.value && i1.value && i2.value && i3.value && i4.value && i5.value) {
      this.setState({ disableSubmitButton: false });
    } else {
      this.setState({ disableSubmitButton: true });
    }
  };

  generateOtp = (type) => {
    this.setState({ generatingOtp: true }, async () => {
      let { url, body } = getApiData("getOtp");

      body = JSON.parse(JSON.stringify(body));
      let generateOtpinterval;
      body.request.payload.lang = this.getLanguage();
      body.request.payload.posvRefNumber = this.getEncryptedData();
      body.request.payload.clubbeOtpDetails = this.state.clubbeOtpDetails;
      body.request.payload.journeyBy = localStorage.getItem("journeyBy");

      if (type !== "call") {
        console.log(
          "this.state.callAttemptsSuccess",
          this.state.callAttemptsSuccess
        );
        this.setState({
          showGenerateOtpTime: true,
          disableGenerateOtpButton: true,
          generateOtpAttempts: ++this.state.generateOtpAttempts,
          disableCallButton: true,
          // showCallButton: true,
        });
        if (this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
          body.request.payload.regenerateOTP = "Y";
        } else {
          body.request.payload.regenerateOTP = "N";
        }
        generateOtpinterval = setInterval(() => {
          this.setState({ generateOtpTime: --this.state.generateOtpTime });
          if (this.state.generateOtpTime === 0) {
            clearInterval(generateOtpinterval);
            if (this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
              this.setState({
                disableGenerateOtpButton: true,
                showCallButton: true,
              });
            } else {
              this.setState({ disableGenerateOtpButton: false });
            }

            if (this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
              this.setState({
                attemptErrorMsg:
                  "You have exceeded the OTP on SMS and Email attempts, please click Get OTP on call",
                showGenerateOtpbtn: false,
              });
            }
            this.setState({
              showGenerateOtpTime: false,
              generateOtpTime: 60,
              // showCallButton: true,
              disableCallButton: false,
            });

            if (this.state.callAttemptsSuccess >= 1) {
              this.setState({ disableCallButton: true });
            }
          }
        }, 1000);
      }

      if (type === "call") {
        console.log(
          "this.state.generateOtpAttempts",
          this.state.generateOtpAttempts
        );
        if (!this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED) {
          this.setState({ disableGenerateOtpButton: false });
        }
        this.setState({ showCallTime: false, disableCallButton: true });
        body.request.payload.onCallOTP = "Yes";
        if (this.state.callOtpTime === 0) {
          if (
            this.state.enableOtpOnCallButton === "N" &&
            this.state.callAttemptsSuccess >= 1
          ) {
            this.setState({ disableCallButton: true });
          } else {
            this.setState({ disableCallButton: false });
          }
          this.setState({
            showCallTime: false,
            // callOtpTime: 60
            // disableGenerateOtpButton: false
          });
        }
      }

      try {
        this.props.showLoader(true);
        const response = await axios.post(url, body);
        let { enableOtpButton, enableOtpOnCallButton } =
          response.data.response.payload;
        this.setState({
          displayMessage: response.data.response.payload.levelMessage
            ? response.data.response.payload.levelMessage
            : response.data.response.payload.businessMsg
              ? response.data.response.payload.businessMsg
              : this.props.t("Please click on Generate OTP to proceed"),
          enableOtpButton,
          enableOtpOnCallButton,
        });
        if (type === "call") {
          this.setState(
            { callAttemptsSuccess: this.state.callAttemptsSuccess + 1 },
            () => {
              if (this.state.callAttemptsSuccess >= 1) {
                this.setState({ disableCallButton: true });
              }
            }
          );
        }
      } catch (err) {
        if (generateOtpinterval) {
          clearInterval(generateOtpinterval);
        }

        this.setState({
          showGenerateOtpTime: false,
          generateOtpTime: 60,
          disableGenerateOtpButton: false,
        });
        if (this.state.callAttemptsSuccess >= 1) {
          this.setState({
            showCallTime: false,
            callOtpTime: 60,
            disableCallButton: false,
          });
        }

        this.handleSnackbar(true, "error", "Please try again");
      } finally {
        this.props.showLoader(false);
        this.setState({
          generatingOtp: false,
          // showCallButton: true,
          otpButtonText: "Resend",
        });
        if (
          this.state.callAttemptsSuccess >= 1 &&
          this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED
        ) {
          this.setState({ attemptErrorMsg: "Please wait for some time." });
        }
        setTimeout(() => {
          if (
            this.state.callAttemptsSuccess >= 1 &&
            this.state.generateOtpAttempts >= GENERATE_OTP_ATTEMPTS_ALLOWED
          ) {
            this.setState({
              attemptErrorMsg:
                "You have exceeded all your attempts to receive OTP, please contact the helpdesk No. 1800 121 8143/ 1800 102 8672",
            });
          }
        }, 20000);
      }
    });
  };

  handleCheckbox = (value) => {
    this.setState({ checkboxValue: value });
  };

  checkMergeChunkStatus = async () => {
    const { url } = getApiData("verifyVideoStatus");
    this.setState({ submitting: true });
    const { posvRefNumber } = this.state;
    const lposvInsurer = localStorage.getItem("journeyBy") === "I" ? "Y" : "N";
    const body = {
      posvRefNumber,
      lposvInsurer,
      extension: "mp4"
    }
    const token = sessionStorage.getItem('mt')
    try {
      const response = await Axios.post(url, body, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      if (response.data.response.msgInfo.msgCode === "200") {
        this.setState({ submitting: false });
        this.submit()
      } else if (response.data.response.msgInfo.msgCode === "203") {
        console.log("In Progess")
        const { mergeStatusRetry } = this.state
        if (mergeStatusRetry) {
          this.setState({ showMergeChunkErrDialog: true, submitting: false })
        } else {
          this.setState({ mergeStatusRetry: true })
          setTimeout(() => {
            this.checkMergeChunkStatus()
          }, 2000)
        }
      } else {
        this.setState({ showMergeChunkErrDialog: true, submitting: false })
      }
    } catch (err) {
      this.setState({ showMergeChunkErrDialog: true, submitting: false })
    }
  }

  handleOtpSubmit = () => {
    const { isVideoPosv } = this.state
    const isProposerJourney = localStorage.getItem("journeyBy") === "P"
    if (isVideoPosv === "Y" && !isProposerJourney) {
      this.checkMergeChunkStatus()
    } else {
      this.submit()
    }
  }

  submit = async () => {
    this.props.showLoader(true);
    this.setState({ submitting: true });
    const { url, body } = getApiData("declaration");
    body.request.payload.customerDisclaimer = "Agreed";
    try {
      await axios.post(url, body);
      this.SubmitOtp();
    } catch (err) {
      console.log({ err })
      this.props.showLoader(false);
      this.setState({ submitting: false });
      if (!isNewUI()) {
        this.handleSnackbar(
          true,
          "error",
          "Something went wrong. Please try again"
        );
      }
    }
  };

  SubmitOtp = async () => {
    const { journeyBy, showGoGreenSection, goGreenFlag, getAlertsCheckbox, declarationObj, isBasbaConsentChecked, isUpfrontPaymentConsentChecked, isTmbChannel, showNewGoGreenUi, isTelebindingJourney } = this.state;
    const inps = document.getElementsByClassName("input_otp");
    let otp = "";
    for (let inp of inps) {
      otp += inp.value;
    }
    const { url, body } = getApiData("validateOtp");
    const policyQuesMap = sessionStorage.getItem("policyQuesMap")
    const isBasbaConsentRequired = localStorage.getItem("basbaConsent") === CAPS_Y;
    const isUpfrontPaymentConsentRequired = localStorage.getItem("upfrontPaymentConsent") === CAPS_Y;
    if(!isTelebindingJourney) {
      body.request.payload.otp = otp;
    }
    body.request.payload.autoFilledOtp = this.state.autoFilledOtp;
    body.request.payload.isRegularUpdate = getAlertsCheckbox;
    body.request.payload.cisConsentOnOtp = this.state.cisConsentOnOtp["english"];
    body.request.payload.journeyBy = localStorage.getItem("journeyBy");
    if (isBasbaConsentRequired && isBasbaConsentChecked) {
      body.request.payload.basbaConsentOnOtp = getOTPDeclarationFromStorage(DECLRATION_IDS.BASBA_CONSENT)["english"]
    }
    if (isUpfrontPaymentConsentRequired && isUpfrontPaymentConsentChecked) {
      body.request.payload.upfrontPaymentConsentOnOtp = getOTPDeclarationFromStorage(DECLRATION_IDS.UPFRONT_PAYMENT_CONSENT)["english"]
    }
    if (journeyBy == "P") {
      body.request.payload.clubbeOtpDetails = this.state.clubbeOtpDetails;
      body.request.payload.policyQuestions = JSON.parse(policyQuesMap)
    }
    if (showGoGreenSection === "Y" || showNewGoGreenUi) {
      body.request.payload.goGreen = showNewGoGreenUi ? CAPS_Y : goGreenFlag
    }

    if (isTmbChannel) {
      const [firstPara, secondPara] = this.fromatTMBConsent("english")
      body.request.payload.tmbConsentOnOtp = `${firstPara} ${secondPara}`;
    }

    if (isTelebindingJourney) {
      delete body.request.payload.otp;
      body.request.payload.submitConsentAfterPosv = "Y";
      body.request.payload.validateOtpForTbLink = "N";
    }

    try {
      const response = await axios.post(url, body);
      console.log("response", response);
      const { submissionRestricted, businessMsg, isPolicyInactive } =
        response.data.response.payload;

      if (isPolicyInactive === true) {
        localStorage.setItem('showNewUI','Y')
        if (businessMsg) {
          sessionStorage.setItem("expiredBusinessMsg", businessMsg);
        }
        this.setState({
          businessMsg: businessMsg ||  "Your link has been expired, kindly connect with seller"
        });

        this.props.history.push('/blocked_journey?s=pi');
        return;
      }


      if (submissionRestricted === "Y") {
        this.setState({
          submissionRestricted: "Y",
          businessMsg
        });
        return;
      }
      if (response.data.response.messageInfo.msgCode === "700") {
        this.setState({
          submitting: false,
          wrongOtpErr: true,
          wrongOtpErrmsg: response.data.response.payload.businessMsg,
        });
        return;
      }

      document.removeEventListener("keyup", this.inputFunction);
      this.setState({ submitting: false });

      let redirectionUrl = "";
      if (isTelebindingJourney) {
        const isPhoneBanking = sessionStorage.getItem('isPhoneBanking') === CAPS_Y
        if (response.data.response.payload.teleBStage === TELEBINDING_STAGES.POSV || isPhoneBanking) {
          redirectionUrl =  "/thankyou";
        } else {
          redirectionUrl = ROUTES.PAYMENT;
        }
      } else {
        redirectionUrl = "/thankyou";
      }
      
      this.props.history.push(redirectionUrl);
    } catch (err) {
      this.setState({ submitting: false });
      this.handleSnackbar(
        true,
        "error",
        "Something went wrong. Please check otp and try again"
      );
    } finally {
      this.props.showLoader(false);
      this.setState({ submitting: false });
    }
  };

  handleSnackbar = (showSnackbar, snackbarMsgType, snackbarMsg) => {
    this.setState({ showSnackbar, snackbarMsgType, snackbarMsg });
    setTimeout(() => {
      this.closeSnackbar();
    }, 2500);
  };

  getSteps = () => {
    if (this.state.isNps == "Y" || this.state.journeyBy == "P") {
      return isNpsSteps;
    } else if (this.state.isVideoPosv == "Y") {
      return hybridPosvSteps;
    } else if (this.state.twoStep == "Y") {
      return QCSteps;
    } else {
      return photoVerificationSteps;
    }
  };

  closeSnackbar = () => {
    this.setState({
      showSnackbar: false,
      snackbarMsgType: "",
      snackbarMsg: "",
    });
  };

  getDeclarationForDisplay = (text) => {
    const { lessText } = this.state;
    if (lessText && text.length > 150) {
      return text.slice(0, 150);
    } else {
      return text;
    }
  };

  handleClubbedOtpSubmit = async (clubbeOtpDetails) => {
    this.setState({ clubbeOtpDetails });
    this.setState({ showClubbedOtpPage: false });
    this.generateOtp("generate");
  };

  resendOtpTextUI = (text) => {
    const splittedText = text.split("?");
    return (
      <>
        <span className="didnt-recieved-otp-text">{splittedText[0]} ?</span>
        <span className="resend_otp_btn">{splittedText[1]} </span>
      </>
    );
  };

  handleReadMore = () => {
    this.setState({ readMoreDisclaimer: !this.state.readMoreDisclaimer });
  };

  getPanLinkedDisclaimer = () => {
    const { readMoreDisclaimer } = this.state;
    const PAN_LINK_DISCLAIMER = getOTPDeclarationFromStorage(DECLRATION_IDS.IS_PAN_AADHAR_LINKED)[getUserLang()];

    return (
      <div className="disclaimer-text-pan">
        <p className="disclaimer-heading-pan">{this.props.t("Disclaimer")}:</p>
        <p>
          {readMoreDisclaimer
            ? PAN_LINK_DISCLAIMER
            : PAN_LINK_DISCLAIMER.slice(0, 150)}{readMoreDisclaimer ? '' : "..."}
          <span className="read-more-pan" onClick={this.handleReadMore}>
            {readMoreDisclaimer ? this.props.t("Read less") : this.props.t("Read more")}
          </span>
        </p>
        {/* {PAN_LINK_DISCLAIMER.length > 150 && ( */}
        {/* )} */}
      </div>
    )
  };

  getTextForDisplay = (declaration, isReadMore) => {
    return isReadMore ? declaration : declaration.slice(0, 150)
  }

  validateSubmitButton = () => {
    const {
      aadharCheckbox,
      customerConsentAfyp,
      isPanAadharLinked,
      submitting,
      disableSubmitButton,
      checkboxValue,
      showOTPPage,
      taliBICheckbox,
      isWipClubbed,
      journeyBy,
      isTmbChannel,
      tmbChecboxVal,
    } = this.state;
    const { showDeclaration } = this.state.declarationObj;
    if(isTmbChannel && !tmbChecboxVal) return false;
    if (
      (customerConsentAfyp == "Y" || isPanAadharLinked == "N") &&
      !aadharCheckbox
    ) {
      return false;
    }

    if (submitting || disableSubmitButton) {
      return false;
    }

    if (showDeclaration && showOTPPage !== "Y" && !checkboxValue) {
      return false;
    }

    if (journeyBy === "P" && isWipClubbed === "Y" && !taliBICheckbox) {
      return false;
    }

    return true;
  };

  autofilledOtpFunction = (value) => {
    this.setState({ autoFilledOtp: value });
  };

  handleGoGreenCheckbox = (e) => {
    let value = e.target.checked ? 'Y' : 'N';
    this.setState({ goGreenFlag: value })
  }

  handleBiPageDisplay = () => {
    const { isTelebindingJourney } = this.state;
    this.setState({ showBiPage: false });
    if (!isTelebindingJourney) {
      this.generateOtp("generate");
    }
  }

  fromatTMBConsent = (lang = null) => {
    const policyNumber = localStorage.getItem("policyNumber")
    const tmbConsentTxt = getOTPDeclarationFromStorage(DECLRATION_IDS.TMB_CHANNEL_CONSENT)[lang ?? getUserLang()]
    const [firstPara, secondPara] = tmbConsentTxt.replace("<POLICY_NUMBER>", policyNumber).split("^^^")
    return ([firstPara, secondPara])
  }

  renderTMBConsent = () => {
    const { readMoreTmbConsent, tmbChecboxVal } = this.state;
    const [firstPara, secondPara] = this.fromatTMBConsent()
    return (
      <fieldset className="sec-declaration talic">
        <label className="generateotp-checkobox">
          <input
            type="checkbox"
            value={tmbChecboxVal}
            onChange={(event) => this.setState({ tmbChecboxVal: event.target.checked })}
          />
          <span className="checkmark"></span>
        </label>
        <div className='check-sec'>
          <div>
            {
              readMoreTmbConsent ? (
                <>
                  <p className="check-sec">{firstPara}</p>
                  <br />
                  <p className="check-sec second-dec-tmb">
                    {secondPara}
                    <button className='read_more_otp_dec' onClick={(e) => { e.preventDefault(); this.setState({ readMoreTmbConsent: !readMoreTmbConsent }) }}>
                      {readMoreTmbConsent ? this.props.t("Read less") : this.props.t("Read more")}
                    </button>
                  </p>
                </>
              ) : (
                <p className="check-sec">
                  {firstPara.slice(0, 190)}...
                  <button className='read_more_otp_dec' onClick={(e) => { e.preventDefault(); this.setState({ readMoreTmbConsent: !readMoreTmbConsent }) }}>
                    {readMoreTmbConsent ? this.props.t("Read less") : this.props.t("Read more")}
                  </button>
                </p>
              )
            }
          </div>
        </div>
      </fieldset>

    )
  }

  render() {
    const {
      submissionRestricted,
      attemptErrorMsg,
      businessMsg,
      generateOtpAttempts,
      showGenerateOtpbtn,
      wrongOtpErrmsg,
      showSnackbar,
      showOTPPage,
      displayMessage,
      submitting,
      showCallButton,
      disableGenerateOtpButton,
      showGenerateOtpTime,
      otpButtonText,
      snackbarMsgType,
      snackbarMsg,
      generateOtpTime,
      disableCallButton,
      showCallTime,
      callOtpTime,
      disableSubmitButton,
      btnText,
      wrongOtpErr,
      showClubbedOtpPage,
      isWipClubbed,
      isPanAadharLinked,
      customerConsentAfyp,
      goGreenFlag,
      showGoGreenSection,
      showMergeChunkErrDialog,
      journeyBy,
      showBiPage,
      getAlertsCheckbox,
      isPanLinked,
      isBasbaConsentChecked,
      isUpfrontPaymentConsentChecked,
      isBasbaConsentApplicable,
      isUpfrontPaymentConsentApplicable,
      isReadmoreBasba,
      isReadmoreUpfront,
      isTmbChannel,
      showNewGoGreenUi,
      isTelebindingJourney,
      isReadmoreAxisMandate,
      isReadmoreDirectDebit,
    } = this.state;
    const { showDeclaration, declaration } = this.state.declarationObj;
    if (!isNewUI()) {
      return <GenerateOtpOld />;
    }
    if (showBiPage) {
      return <BIPage handleBiPageDisplay={this.handleBiPageDisplay} />
    }
    return (
      <>
        {showMergeChunkErrDialog && <MergeChunkErrorDialog />}
        {submitting && <DotsLoader msg={this.props.t('Please wait while we are validating OTP')} />}
        {submissionRestricted === "Y" ? (
          <BlockedJourneyNew
            businessMsgGenerate={businessMsg}
            submissionRestrictedGenerate={submissionRestricted}
          />
        ) : showClubbedOtpPage && isWipClubbed == "Y" ? (
          <ClubbedOtp submitHandler={this.handleClubbedOtpSubmit} />
        ) : (
          <div className="generateOtp-container">
            <div className="alrt-msg">
              {showSnackbar ? (
                <Snackbar
                  closeSnackbar={this.closeSnackbar}
                  snackbarMsgType={snackbarMsgType}
                  snackbarMsg={this.props.t(`${snackbarMsg}`)}
                />
              ) : null}
            </div>

            {showOTPPage !== "Y" ? (
              <div className={`dsclmr-wrap ${isTelebindingJourney ? 'telebinding' : ''}`}>
                    {isTelebindingJourney && (
                      <div className="video-consent-heading">
                        <p>Required Consent/s</p>
                      </div>
                    )}
                {!isTelebindingJourney && <div className="generate-otp__grid">
                  <div>
                    {journeyBy !== "P" && <p className="alomost-ended">
                      {this.props.t("Almost there")}
                    </p>}
                    <p className="enter-otp">{this.props.t("Enter OTP")}</p>
                    <p className="head_text">
                      {this.props.t(`${displayMessage}`)}
                    </p>
                    <p className="small-txt">
                      {this.props.t(`${attemptErrorMsg}`)}
                    </p>
                  </div>

                  <div className="otpandBtn">
                    <div
                      className="otpImport"
                      style={{
                        display: "flex",
                        justifyContent: "flex-start;",
                        marginTop: "20px",
                      }}
                    >
                      <Otp
                        submitting={submitting}
                        inputFunction={this.inputFunction}
                        wrongOtpErr={wrongOtpErr}
                        autofilledOtpFunction={this.autofilledOtpFunction}
                        removeWrongOtpClass={() => {
                          this.setState({ wrongOtpErr: false });
                        }}
                      />
                    </div>
                    {wrongOtpErr ? (
                      <div className="wrongOtpErrmsg">
                        {wrongOtpErrmsg}{" "}
                        <button
                          disabled={submitting || disableGenerateOtpButton}
                          className="generateOtp_text generateOtp_text_black"
                          onClick={() => this.generateOtp("generate")}
                        >
                          Resend
                          {showGenerateOtpTime ? (
                            <span className="otpTime">
                              {" "}
                              in{" "}
                              <span className="green-time">
                                {" "}
                                00:
                                {generateOtpTime >= 10
                                  ? generateOtpTime
                                  : `0${generateOtpTime}`}
                              </span>
                            </span>
                          ) : (
                            ""
                          )}
                        </button>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="buttons_div__otp">
                      {showGenerateOtpbtn ? (
                        <div className="btn-time">
                          {!wrongOtpErr && (
                            <button
                              disabled={submitting || disableGenerateOtpButton}
                              className="generateOtp_text"
                              onClick={() => this.generateOtp("generate")}
                            >
                              {showGenerateOtpTime ? (
                                <span className="otpTime">
                                  {this.resendOtpTextUI(
                                    this.props.t(
                                      "Didn’t receive the OTP? Resend in"
                                    )
                                  )}
                                  <span className="green-time">
                                    00:
                                    {generateOtpTime >= 10
                                      ? generateOtpTime
                                      : `0${generateOtpTime}`}
                                  </span>
                                </span>
                              ) : generateOtpAttempts < 1 ? (
                                this.props.t(`${otpButtonText}`)
                              ) : (
                                <span className="otpTime">
                                  {this.resendOtpTextUI(
                                    this.props.t(
                                      "Didn’t receive the OTP? Resend"
                                    )
                                  )}
                                  {/* Didn’t receive the OTP?{" "}
                                  <span className="resend_otp_btn">
                                    {otpButtonText}
                                  </span> */}
                                </span>
                              )}
                            </button>
                          )}{" "}
                        </div>
                      ) : null}
                    </div>

                    <div className="buttons_div__otp otp-call-btn">
                      <div className="btn-time">
                        <Button
                          disabled={submitting || disableCallButton}
                          className="generateOtp_text"
                          id="call_button"
                          onClick={() => this.generateOtp("call")}
                          buttonType="neutralLink"
                          iconLeft={<CallIcon />}
                        >
                          {showCallTime ? (
                            <span className="otpTime">
                              {this.resendOtpTextUI(
                                this.props.t(
                                  "Didn’t receive the OTP? Resend in"
                                )
                              )}
                              <span className="green-time">{callOtpTime}</span>
                            </span>
                          ) : (
                            this.props.t("otponcall")
                          )}
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>}
                {isPanLinked === "N" && this.getPanLinkedDisclaimer()}
                {showGoGreenSection === "Y" && !showNewGoGreenUi && <GoGreenSection goGreenFlag={goGreenFlag} handleGoGreenCheckbox={this.handleGoGreenCheckbox} />}
                {showNewGoGreenUi && <GoGreenPolicyPack />}
                {showDeclaration ? (
                  <>
                    <div className="tnc-txt">
                      <form>
                        {isTmbChannel && this.renderTMBConsent()}
                        {journeyBy === "P" && isWipClubbed === "Y" && <fieldset className="sec-declaration talic">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={this.state.taliBICheckbox}
                              onChange={(event) =>
                                this.setState({
                                  taliBICheckbox: event.target.checked,
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {" "}
                            {/* {this.getDeclarationForDisplay(
                              this.props.t(`${talicBIDisclaimer}`)
                            )} */}
                            {/* {this.props.t("talic_bi_disclaimer")} */}
                            {getOTPDeclarationFromStorage(DECLRATION_IDS.TALIC_BI_DISCLAIMER)[getUserLang()]}
                            {/* <span
                              onClick={this.readMoreText}
                              className="read_more_otp_dec"
                            >
                              {" "}
                              {this.props.t(btnText)}
                            </span> */}
                          </p>
                        </fieldset>}
                        <fieldset>
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={this.state.checkboxValue}
                              onChange={(event) =>
                                this.handleCheckbox(event.target.checked)
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {" "}
                            {this.getDeclarationForDisplay(
                              this.props.t(`${declaration}`)
                            )}
                            <span
                              onClick={this.readMoreText}
                              className="read_more_otp_dec"
                            >
                              {" "}
                              {this.props.t(`${btnText}`)}
                            </span>
                          </p>
                        </fieldset>
                        {(customerConsentAfyp == "Y" ||
                          isPanAadharLinked == "N") && (
                            <fieldset className="sec-declaration">
                              <label className="generateotp-checkobox">
                                <input
                                  disabled={this.state.submitting}
                                  type="checkbox"
                                  value={this.state.aadharCheckbox}
                                  onChange={(event) =>
                                    this.setState({
                                      aadharCheckbox: event.target.checked,
                                    })
                                  }
                                />
                                <span className="checkmark"></span>
                              </label>
                              <p className="check-sec">
                                {" "}
                                {/* {this.props.t(
                                  "pan_addhar_declaration"
                                )} */}
                                {getOTPDeclarationFromStorage(DECLRATION_IDS.PAN_ADDHAR_DECLARATION)[getUserLang()]}
                                <span
                                  onClick={this.readMoreText}
                                  className="read_more_otp_dec"
                                >
                                  {" "}
                                </span>
                              </p>
                            </fieldset>
                          )}
                        <fieldset className="sec-declaration">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={getAlertsCheckbox}
                              checked={getAlertsCheckbox === CAPS_Y}
                              onChange={(event) =>
                                this.setState({
                                  getAlertsCheckbox: (event.target.checked ? CAPS_Y : CAPS_N),
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {/* {this.props.t(regularAlertsDiscalimer)} */}
                            {getOTPDeclarationFromStorage(DECLRATION_IDS.REGULAR_OTP_DISCLAIMER)[getUserLang()]}
                          </p>
                        </fieldset>

                        {isBasbaConsentApplicable && <fieldset className="sec-declaration">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={isBasbaConsentChecked}
                              checked={isBasbaConsentChecked}
                              onChange={(event) =>
                                this.setState({
                                  isBasbaConsentChecked: event.target.checked,
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">

                            {this.getTextForDisplay(getOTPDeclarationFromStorage(DECLRATION_IDS.BASBA_CONSENT)[getUserLang()], isReadmoreBasba)}
                            <span className="read_more_otp_dec" onClick={() => this.setState({ isReadmoreBasba: !isReadmoreBasba })}>
                              {isReadmoreBasba ? this.props.t("Read less") : this.props.t("Read more")}
                            </span>
                          </p>
                        </fieldset>}
                        {isUpfrontPaymentConsentApplicable && <fieldset className="sec-declaration">
                          <label className="generateotp-checkobox">
                            <input
                              disabled={this.state.submitting}
                              type="checkbox"
                              value={isUpfrontPaymentConsentChecked}
                              checked={isUpfrontPaymentConsentChecked}
                              onChange={(event) =>
                                this.setState({
                                  isUpfrontPaymentConsentChecked: event.target.checked,
                                })
                              }
                            />
                            <span className="checkmark"></span>
                          </label>
                          <p className="check-sec">
                            {this.getTextForDisplay(getOTPDeclarationFromStorage(DECLRATION_IDS.UPFRONT_PAYMENT_CONSENT)[getUserLang()], isReadmoreUpfront)}
                            <span className="read_more_otp_dec" onClick={() => this.setState({ isReadmoreUpfront: !isReadmoreUpfront })}>
                              {isReadmoreUpfront ? this.props.t("Read less") : this.props.t("Read more")}
                            </span>
                          </p>
                        </fieldset>}
                      </form>
                    </div>

                  </>
                ) : (
                  <>
                    <div className="button_div_unified">
                      <Button
                        className="submit_button--generate_otp"
                        onClick={this.handleOtpSubmit}
                        disabled={!this.validateSubmitButton()}
                        buttonType="primary"
                        width="264"
                      >
                        {this.props.t("Submit")}
                      </Button>
                    </div>
                  </>
                )}
              </div>
            ) : (
              <Error errorMsg={this.state.errorMsg} />
            )}
            {showDeclaration && this.state.showOTPPage !== "Y" ? (
              <div className="button_div_unified">
                <Button
                  className="submit_button--generate_otp"
                  onClick={this.handleOtpSubmit}
                  disabled={!this.validateSubmitButton()}
                  buttonType="primary"
                  width="264"
                >
                  {this.props.t("Submit")}
                </Button>
              </div>
            ) : null}
          </div>
          // )
        )}
      </>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showLoader }),
  withTranslation()
)(GenerateOtp);

GenerateOtp.contextType = SpeakerContext;
